var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 41,
  height: 42,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20.992,
  r: 20.5,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M13.073 21.352a.47.47 0 0 1-.141-.354c0-.283.219-.502.502-.502l14.135.007c.283 0 .502.22.502.502s-.22.502-.502.502L13.434 21.5a.5.5 0 0 1-.354-.141z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "M20.144 28.423a.47.47 0 0 1-.141-.354l.007-14.135c0-.283.22-.502.502-.502s.502.22.502.502l-.007 14.135c0 .283-.22.502-.502.502a.5.5 0 0 1-.354-.141z"
})));
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWVmOTI5MDViODkyYmEyMDVhNzJlNGM1MjNlYjYzOWMuc3ZnIjs=";